module.exports = __webpack_public_path__ + "static/media/plus-light.2e3b0138.svg";